import { render, staticRenderFns } from "./CreateGroupOrder.vue?vue&type=template&id=6854cbb5&"
import script from "./CreateGroupOrder.vue?vue&type=script&lang=js&"
export * from "./CreateGroupOrder.vue?vue&type=script&lang=js&"
import style0 from "./CreateGroupOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports